// SHADOW MARKET™ — i18n del pago con R₿L (ES/EN/SK).
// Mismo patrón per-feature que shop.js / rbl-payments.js.

const ES = {
  payWithRBL: "Pagar con R₿L",
  discount25: "25% de descuento",
  originalPrice: "Precio original",
  discountRBL: "Descuento R₿L (25%)",
  shipping: "Envío",
  shippingFree: "GRATIS",
  finalPrice: "Precio final",
  equivalentRBL: "Equivalente en R₿L",
  currentPrice: "Precio actual R₿L",
  updatePrice: "Actualizar precio",
  insufficientBalance: "Balance insuficiente de R₿L",
  yourBalance: "Tu balance",
  missing: "Te faltan",
  buyRBL: "Comprar R₿L",
  confirmPayment: "Confirmar pago",
  walletConfirm: "Confirma en tu wallet…",
  processing: "Procesando en Base L2…",
  verifying: "Verificando TX y creando el pedido…",
  orderConfirmed: "¡Pedido confirmado!",
  orderNumber: "Nº de pedido",
  banner: "Paga con $R₿L y obtén un 25% de descuento en toda la tienda",
  badgeDiscount: "-25% con R₿L",
  connectWallet: "Conectar wallet",
  selectWallet: "Selecciona tu wallet",
  wrongNet: "Cambia a Base L2 para pagar",
  switchBase: "Cambiar a Base",
  priceNote: "Precio calculado en tiempo real",
  priceUnavailable: "Precio R₿L no disponible ahora mismo — usa el pago en euros",
  viewTx: "Ver transacción",
  retry: "Reintentar",
  retryVerify: "Reintentar verificación",
  error: "Error en el pago",
  injected: "MetaMask / Wallet del navegador",
  shippingTitle: "Dirección de envío",
  fullName: "Nombre completo",
  addressLine1: "Dirección",
  addressLine2: "Dirección 2 (opcional)",
  city: "Ciudad",
  postalCode: "Código postal",
  country: "País",
  phone: "Teléfono (opcional)",
  emailLabel: "Email para la confirmación",
  fillShipping: "Completa la dirección de envío para continuar",
  successSub: "Recibirás un email de confirmación. ¡Gracias, rebelde!",
  disconnect: "desconectar",
};

const EN = {
  payWithRBL: "Pay with R₿L",
  discount25: "25% discount",
  originalPrice: "Original price",
  discountRBL: "R₿L discount (25%)",
  shipping: "Shipping",
  shippingFree: "FREE",
  finalPrice: "Final price",
  equivalentRBL: "Equivalent in R₿L",
  currentPrice: "Current R₿L price",
  updatePrice: "Update price",
  insufficientBalance: "Insufficient R₿L balance",
  yourBalance: "Your balance",
  missing: "You need",
  buyRBL: "Buy R₿L",
  confirmPayment: "Confirm payment",
  walletConfirm: "Confirm in your wallet…",
  processing: "Processing on Base L2…",
  verifying: "Verifying TX and creating the order…",
  orderConfirmed: "Order confirmed!",
  orderNumber: "Order no.",
  banner: "Pay with $R₿L and get 25% off everything in the store",
  badgeDiscount: "-25% with R₿L",
  connectWallet: "Connect wallet",
  selectWallet: "Select your wallet",
  wrongNet: "Switch to Base L2 to pay",
  switchBase: "Switch to Base",
  priceNote: "Price calculated in real time",
  priceUnavailable: "R₿L price unavailable right now — use the EUR payment",
  viewTx: "View transaction",
  retry: "Retry",
  retryVerify: "Retry verification",
  error: "Payment error",
  youPaid: "You paid",
  toAcademyNote: "→ 95% to RE₿EL Academy",
  marketBurnNote: "🔥 5% burned permanently",
  viewBurnTx: "View burn TX on Basescan",
  injected: "MetaMask / Browser wallet",
  shippingTitle: "Shipping address",
  fullName: "Full name",
  addressLine1: "Address",
  addressLine2: "Address 2 (optional)",
  city: "City",
  postalCode: "Postal code",
  country: "Country",
  phone: "Phone (optional)",
  emailLabel: "Email for the confirmation",
  fillShipping: "Fill in the shipping address to continue",
  successSub: "You will receive a confirmation email. Thanks, rebel!",
  disconnect: "disconnect",
};

const SK = {
  payWithRBL: "Zaplatiť s R₿L",
  discount25: "25% zľava",
  originalPrice: "Pôvodná cena",
  discountRBL: "Zľava R₿L (25%)",
  shipping: "Doprava",
  shippingFree: "ZADARMO",
  finalPrice: "Finálna cena",
  equivalentRBL: "Ekvivalent v R₿L",
  currentPrice: "Aktuálna cena R₿L",
  updatePrice: "Aktualizovať cenu",
  insufficientBalance: "Nedostatočný zostatok R₿L",
  yourBalance: "Tvoj zostatok",
  missing: "Chýba ti",
  buyRBL: "Kúpiť R₿L",
  confirmPayment: "Potvrdiť platbu",
  walletConfirm: "Potvrď v peňaženke…",
  processing: "Spracúvanie na Base L2…",
  verifying: "Overujem TX a vytváram objednávku…",
  orderConfirmed: "Objednávka potvrdená!",
  orderNumber: "Č. objednávky",
  banner: "Zaplať s $R₿L a získaj 25% zľavu v celom obchode",
  badgeDiscount: "-25% s R₿L",
  connectWallet: "Pripojiť peňaženku",
  selectWallet: "Vyber peňaženku",
  wrongNet: "Prepni na Base L2 pre platbu",
  switchBase: "Prepnúť na Base",
  priceNote: "Cena vypočítaná v reálnom čase",
  priceUnavailable: "Cena R₿L momentálne nedostupná — použi platbu v eurách",
  viewTx: "Zobraziť transakciu",
  retry: "Skúsiť znova",
  retryVerify: "Skúsiť overenie znova",
  error: "Chyba platby",
  youPaid: "Zaplatil si",
  toAcademyNote: "→ 95% pre RE₿EL Academy",
  marketBurnNote: "🔥 5% spálené natrvalo",
  viewBurnTx: "Zobraziť burn TX na Basescan",
  injected: "MetaMask / Peňaženka prehliadača",
  shippingTitle: "Dodacia adresa",
  fullName: "Celé meno",
  addressLine1: "Adresa",
  addressLine2: "Adresa 2 (voliteľné)",
  city: "Mesto",
  postalCode: "PSČ",
  country: "Krajina",
  phone: "Telefón (voliteľné)",
  emailLabel: "Email pre potvrdenie",
  fillShipping: "Vyplň dodaciu adresu pre pokračovanie",
  successSub: "Dostaneš potvrdzujúci email. Vďaka, rebel!",
  disconnect: "odpojiť",
};

const DE = {
  payWithRBL: "Mit R₿L bezahlen",
  discount25: "25% Rabatt",
  originalPrice: "Originalpreis",
  discountRBL: "R₿L-Rabatt (25%)",
  shipping: "Versand",
  shippingFree: "GRATIS",
  finalPrice: "Endpreis",
  equivalentRBL: "Äquivalent in R₿L",
  currentPrice: "Aktueller R₿L-Preis",
  updatePrice: "Preis aktualisieren",
  insufficientBalance: "Unzureichendes R₿L-Guthaben",
  yourBalance: "Dein Guthaben",
  missing: "Dir fehlen",
  buyRBL: "R₿L kaufen",
  confirmPayment: "Zahlung bestätigen",
  walletConfirm: "Bestätige in deiner Wallet…",
  processing: "Verarbeitung auf Base L2…",
  verifying: "TX wird verifiziert und Bestellung wird erstellt…",
  orderConfirmed: "Bestellung bestätigt!",
  orderNumber: "Bestellnummer",
  banner: "Zahle mit $R₿L und erhalte 25% Rabatt im gesamten Shop",
  badgeDiscount: "-25% mit R₿L",
  connectWallet: "Wallet verbinden",
  selectWallet: "Wähle deine Wallet",
  wrongNet: "Wechsle zu Base L2 zum Bezahlen",
  switchBase: "Zu Base wechseln",
  priceNote: "Preis in Echtzeit berechnet",
  priceUnavailable: "R₿L-Preis derzeit nicht verfügbar — nutze die Zahlung in Euro",
  viewTx: "Transaktion anzeigen",
  retry: "Erneut versuchen",
  retryVerify: "Verifizierung erneut versuchen",
  error: "Fehler bei der Zahlung",
  injected: "MetaMask / Browser-Wallet",
  shippingTitle: "Lieferadresse",
  fullName: "Vollständiger Name",
  addressLine1: "Adresse",
  addressLine2: "Adresse 2 (optional)",
  city: "Stadt",
  postalCode: "Postleitzahl",
  country: "Land",
  phone: "Telefon (optional)",
  emailLabel: "E-Mail für Bestätigung",
  fillShipping: "Vervollständige die Lieferadresse, um fortzufahren",
  successSub: "Du erhältst eine Bestätigungs-E-Mail. Danke, Rebell!",
  disconnect: "trennen",
};

const ZH_CN = {
  payWithRBL: "使用 R₿L 支付",
  discount25: "75折优惠",
  originalPrice: "原价",
  discountRBL: "R₿L 折扣（25%）",
  shipping: "运费",
  shippingFree: "免费",
  finalPrice: "最终价格",
  equivalentRBL: "R₿L 等值",
  currentPrice: "当前 R₿L 价格",
  updatePrice: "更新价格",
  insufficientBalance: "R₿L 余额不足",
  yourBalance: "您的余额",
  missing: "还需要",
  buyRBL: "购买 R₿L",
  confirmPayment: "确认支付",
  walletConfirm: "请在钱包中确认…",
  processing: "正在 Base L2 上处理…",
  verifying: "正在验证交易并创建订单…",
  orderConfirmed: "订单已确认！",
  orderNumber: "订单号",
  banner: "使用 $R₿L 支付，全店商品享受25%折扣",
  badgeDiscount: "用 R₿L 享75折",
  connectWallet: "连接钱包",
  selectWallet: "选择您的钱包",
  wrongNet: "切换到 Base L2 进行支付",
  switchBase: "切换到 Base",
  priceNote: "价格实时计算",
  priceUnavailable: "R₿L 价格暂时不可用——请使用欧元支付",
  viewTx: "查看交易",
  retry: "重试",
  retryVerify: "重新验证",
  error: "支付错误",
  injected: "MetaMask / 浏览器钱包",
  shippingTitle: "收货地址",
  fullName: "姓名",
  addressLine1: "地址",
  addressLine2: "地址第2行（可选）",
  city: "城市",
  postalCode: "邮政编码",
  country: "国家",
  phone: "电话（可选）",
  emailLabel: "确认邮箱",
  fillShipping: "请填写收货地址以继续",
  successSub: "您将收到确认邮件。感谢您，反叛者！",
  disconnect: "断开连接",
};

const ALL = { es: ES, en: EN, sk: SK, de: DE, "zh-CN": ZH_CN };

export const useMarketRblI18n = (lang) => ALL[lang] || ES;
